import { render, staticRenderFns } from "./delivery-table.vue?vue&type=template&id=5752871a&scoped=true"
import script from "./delivery-table.vue?vue&type=script&lang=ts"
export * from "./delivery-table.vue?vue&type=script&lang=ts"
import style0 from "./delivery-table.vue?vue&type=style&index=0&id=5752871a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752871a",
  null
  
)

export default component.exports